(function () {
  function getOfferSection(trigger) {
    return (
      trigger.closest('[data-offer-section]') ||
      document.querySelector('[data-offer-section]')
    );
  }

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) {
        ids.push(el.dataset.sectionId);
      }
    });
    return ids;
  }

  function parseVariantId(raw) {
    if (!raw) return null;
    var value = String(raw).trim();
    var match = value.match(/(\d+)$/);
    return match ? match[1] : value;
  }

  function shouldRedirect(url) {
    if (!url) return false;
    var trimmed = String(url).trim();
    if (!trimmed || trimmed === '#' || trimmed === '#buy') return false;
    if (trimmed.charAt(0) === '#') return false;
    return true;
  }

  function isOcuReady() {
    return !!(window.Zipify && window.Zipify.OCU && window.Zipify.OCU.api);
  }

  function waitForOcu(maxMs) {
    maxMs = maxMs || 800;
    return new Promise(function (resolve) {
      if (isOcuReady()) {
        resolve(true);
        return;
      }

      var started = Date.now();
      var timer = window.setInterval(function () {
        if (isOcuReady()) {
          window.clearInterval(timer);
          resolve(true);
          return;
        }

        if (Date.now() - started >= maxMs) {
          window.clearInterval(timer);
          resolve(false);
        }
      }, 50);
    });
  }

  function notifyCartUpdate(cart, sections) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          data: {
            itemCount: cart && cart.item_count != null ? cart.item_count : undefined,
            source: 'offer-program',
            sections: sections || undefined,
          },
        },
      })
    );
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return false;
    if (typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    if (typeof drawer.showDialog === 'function') {
      drawer.showDialog();
      return true;
    }
    return false;
  }

  function triggerOfferFormSubmit(section) {
    var submitButton = section && section.querySelector('[data-offer-form-submit]');
    if (!submitButton) return false;
    submitButton.click();
    return true;
  }

  function addProgramToCart(section) {
    var variantId = parseVariantId(section && section.dataset.offerVariantId);
    var cartAddUrl = (section && section.dataset.cartAddUrl) || '/cart/add.js';
    if (!variantId) {
      return Promise.reject(
        new Error(
          'Program product is not configured. Select "14-Day Face Reset Program" in the Offer section settings.'
        )
      );
    }

    var payload = { items: [{ id: Number(variantId), quantity: 1 }] };
    var sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      payload.sections = sectionIds.join(',');
    }

    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (response) {
      return response.text().then(function (text) {
        var data = {};
        try {
          data = text ? JSON.parse(text) : {};
        } catch (error) {
          data = {};
        }
        if (!response.ok || data.status === 422) {
          var message =
            (data && (data.description || data.message)) ||
            'Could not add the program to your cart. Please try again.';
          throw new Error(message);
        }
        return data;
      });
    });
  }

  function handleOfferCta(event) {
    event.preventDefault();
    var section = getOfferSection(event.currentTarget);
    var trigger = event.currentTarget;
    var redirectUrl = section && section.dataset.offerRedirectUrl;

    if (trigger.getAttribute('aria-busy') === 'true') return;
    trigger.setAttribute('aria-busy', 'true');

    waitForOcu()
      .then(function (ocuReady) {
        if (ocuReady && triggerOfferFormSubmit(section)) {
          return null;
        }

        return addProgramToCart(section).then(function (addResponse) {
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (response) {
              return response.json();
            })
            .then(function (cart) {
              notifyCartUpdate(cart, addResponse && addResponse.sections);
              var opened = openCartDrawer();
              if (!opened) {
                window.location.href = '/cart';
                return;
              }
              if (shouldRedirect(redirectUrl)) {
                window.location.href = redirectUrl;
              }
            });
        });
      })
      .catch(function (error) {
        window.alert(
          error instanceof Error
            ? error.message
            : 'Could not add the program to your cart. Please try again.'
        );
      })
      .finally(function () {
        trigger.removeAttribute('aria-busy');
      });
  }

  function bindOfferCtas(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-offer-add-to-cart]').forEach(function (el) {
      if (el.dataset.offerCartBound === 'true') return;
      el.dataset.offerCartBound = 'true';
      el.addEventListener('click', handleOfferCta);
    });
  }

  function init() {
    bindOfferCtas(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-offer-add-to-cart]')) {
      bindOfferCtas(event.target);
    }
  });
})();
